<template>
  <card>
    <template slot="header">
      <h4 v-if="$slots.title || title" class="card-title">
        <slot name="title">
          {{title}}
        </slot>
      </h4>
      <p class="card-category">
        <slot name="subTitle">
          {{subTitle}}
        </slot>
      </p>
    </template>
    <div>
      <div class="chart-container">
        <canvas ref='canvas'></canvas>
      </div>
      <div class="footer">
        <div class="chart-legend">
          <slot name="legend"></slot>
        </div>
        <hr>
        <div class="stats">
          <slot name="footer">{{footerText}}</slot>
        </div>
        <div class="pull-right">
        </div>
      </div>
    </div>

  </card>
</template>
<script>
import Card from './Card.vue'
import Chart from 'chart.js'

export default {
  name: 'chart-card',
  components: {
    Card
  },
  props: {
    footerText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'pie'
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Object
    },
    options: {
      type: Object,
      default: () => {
        return { legend: {
          display: screen.width > 500,
          position: 'right'
        }
        }
      }
    }
  },
  data () {
    return {
      chard: undefined
    }
  },

  watch: {
    chartData () {
      if (this.chartData) {
        this.initChart()
      }
    }
  },

  methods: {

    defaultOption () {
      return
    },

    initChart () {
      const ctx = this.$refs.canvas.getContext('2d')
      this.chart = new Chart(ctx, {
        type: this.type,
        data: this.chartData,
        options: this.options
      })
    }
  },
  mounted () {
    this.initChart()
  },

  beforeDestroy () {
    if (this.chard) {
      this.chard.destroy()
    }
  }
}
</script>
<style>
.chart-container {
  position: relative;
}
</style>
